$ = require 'jquery'
Alerts = require 'app/scripts/views/lib/alerts'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
{ track, trackUe } = require '@trello/analytics'

TEMPLATES_ALERT_TIMEOUT = 1000

module.exports = class ConvertToTemplateView extends View
  viewTitleKey: 'make template'

  events:
    'submit form': 'convertToTemplate'

  render: ->
    @$el.html(templates.fill(require('app/scripts/views/templates/board_convert_template')))

    @

  convertToTemplate: (e) ->
    Util.stop(e)
    @$('.js-convert').prop('disabled')

    Alerts.show('converting', 'info', 'templates', TEMPLATES_ALERT_TIMEOUT)

    @model.setPref('isTemplate', true).save()

    trackUe('board menu', 'converts', 'board', 'to template', '', 'by clicking template toggle',
      { boardId: @model.id, teamId: @model.getOrganization()?.id })

    return
